import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_API, _CRUD} from './_Action'
import { ICotationComment } from 'src/type/cotation'
import { Criteria } from 'src/type/criteria/criteria'

export const COTATION = 'cotation'
const _COTATION_CRUD = _CRUD(COTATION)

export const getCotation = (productType: string, id: string) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_COTATION_CRUD.GET.REQUEST, _COTATION_CRUD.GET.SUCCESS, _COTATION_CRUD.GET.FAILURE],
      route: route.cotation.get(enterpriseId, productType, id)
    }
  })
}

export const createCotation = (data: any, productType: string) => (dispatch, getState: () => RootState) => {
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_COTATION_CRUD.CREATE.REQUEST, _COTATION_CRUD.CREATE.SUCCESS, _COTATION_CRUD.CREATE.FAILURE],
        route: route.cotation.create(data, enterpriseId, productType)
      }
    })
  }

  
export const updateCotation = (data: any, productType: string, id: string) => (dispatch, getState: () => RootState) => {
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_COTATION_CRUD.UPDATE.REQUEST, _COTATION_CRUD.UPDATE.SUCCESS, _COTATION_CRUD.UPDATE.FAILURE],
        route: route.cotation.update(data, enterpriseId, productType, id)
      }
    })
}

export const duplicateCotation = (productType: string, id: string) => (dispatch, getState: () => RootState): Promise<ICotationComment> => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const actions = _API('duplicate_cotation')
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.cotation.duplicate(enterpriseId, productType, id)
    }
  })
}

export const getUsersToNotify = (productType: string, searchText?: string) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const action = _API('get_user_to_notify')
  return dispatch({
    [_CALL_API]: {
      types: [action.REQUEST, action.SUCCESS, action.FAILURE],
      route: searchText ? route.cotation.getUsersToNotify(enterpriseId, productType, {global_search: searchText}) : route.cotation.getUsersToNotify(enterpriseId, productType)
    }
  })
}

export const getUsersNotify = (ids: string) => (dispatch, getState: () => RootState) => {
  const action = _API('get_user_notify')
  return dispatch({
    [_CALL_API]: {
      types: [action.REQUEST, action.SUCCESS, action.FAILURE],
      route: route.cotation.getUserNotify(ids)
    }
  })
}
  
  
export const getCotationHistory = (productType: string, id: string) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const action = _API('get_user_to_notify')
  return dispatch({
    [_CALL_API]: {
      types: [action.REQUEST, action.SUCCESS, action.FAILURE],
      route: route.cotation.getHistory(enterpriseId, productType, id, {sort_by: "created_at", order_by: "desc"} as Criteria)
    }
  })
}

export const COTATION_COMMENT = 'cotationComment'

export const addComment = (msg: any, productType: string, id: string) => (dispatch, getState: () => RootState): Promise<ICotationComment> => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const actions = _API('add_comment')
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.cotation.addComment(msg, enterpriseId, productType, id)
    }
  })
}

export const getComment = (criteria: any) => (dispatch, getState: () => RootState): Promise<ICotationComment> => {
  const actions = _API('PAGINATE_cotationComment')
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.cotation.getComments(criteria)
    }
  })
}


// WEBPACK FOOTER //
// ./src/core/redux/action/cotationAction.ts